import * as yup from "yup";

export interface TemplateForm {
  name?: string;
  channel?: { label: string; value: string }[];
  data_source?: { label: string; value: string }[];
  data_file_id?: {
    label: string;
    value: number;
    other: string[];
  }[];
  portfolio_category_id?: {
    label: string;
    name: string;
    value: number;
  }[];
  description?: string;
  createdUser?: {
    firstName: string;
    lastName: string;
  };
  createdAt?: string;
  message?: string;
}

export const schema = yup
  .object({
    name: yup.string().required("Name is required"),
    channel: yup.mixed().required("Channel is required"),
    data_source: yup.mixed().required("Data Source is required"),
    portfolio_category_id: yup.mixed().required("Portfolio is required"),
    data_file_id: yup.mixed().when("data_source", {
      is: (dataSourceValue: { label: string; value: string }[] | undefined) =>
        Array.isArray(dataSourceValue) &&
        dataSourceValue[0]?.value === "Data Upload",
      then: (sche) => sche.required("Data File is required"),
      otherwise: (sche) => sche.notRequired(),
    }),
  })
  .required();

export const preDefined = [
  "Customer Name",
  "Due Amount",
  "Loan Type",
  "Due Date",
  "PTP Amount",
  "Committed PTP Date",
  "Currency",
];
